import routerList2 from './router2.config';

// 主要路由
const mainRouterList = [
  {
    path: '/index',
    name: 'index',
    component: () => import('@/layouts/Layout.vue'),
    redirect: '/home',
    children: [
      {
        // 首页
        path: '/home',
        name: 'home',
        meta: { id: '/home' },
        component: () => import(/* webpackChunkName: "Home" */ '@/views/Home/index.vue'),
      },
      {
        // 员工关怀
        path: '/employee-care',
        name: 'staffCare',
        component: () => import(/* webpackChunkName: "StaffCare" */ '@/views/StaffCare/index.vue'),
        redirect: '/employee-care/new-staff',
        meta: { id: '/employee-care' },
        children: [
          {
            // 员工关怀-新员工
            path: '/employee-care/new-staff',
            name: 'newStaff',
            meta: { id: '/employee-care' },
            component: () =>
              import(/* webpackChunkName: "NewStaff" */ '@/views/StaffCare/NewStaff/NewStaff.vue'),
          },
          {
            // 员工关怀-生日员工
            path: '/employee-care/birthday-staff',
            name: 'birthdayStaff',
            meta: { id: '/employee-care' },
            component: () =>
              import(
                /* webpackChunkName: "BirthdayStaff" */ '@/views/StaffCare/BirthdayStaff/BirthdayStaff.vue'
              ),
          },
        ],
      },
      {
        // 设置页面
        path: '/setting',
        name: 'setting',
        meta: { id: 0 },
        component: () => import(/* webpackChunkName: "Setting" */ '@/views/Setting/index.vue'),
        redirect: '/setting/base',
        children: [
          {
            // 设置-基本设置
            path: '/setting/base',
            name: 'settingBase',
            meta: { id: 0 },
            component: () =>
              import(/* webpackChunkName: "BaseSetting" */ '@/views/Setting/Base/Base.vue'),
          },
          {
            // 设置-安全设置
            path: '/setting/safe',
            name: 'settingSafe',
            meta: { id: 0 },
            component: () =>
              import(/* webpackChunkName: "settingSafe" */ '@/views/Setting/Safe/Safe.vue'),
          },
          {
            // 设置-代理设置
            path: '/setting/proxy',
            name: 'settingProxy',
            meta: { id: 0 },
            component: () =>
              import(/* webpackChunkName: "Proxy" */ '@/views/Setting/Proxy/Proxy.vue'),
          },
        ],
      },
      {
        // 设置-安全设置-修改密码
        path: '/setting/safe/modify-password',
        name: 'modifyPassword',
        meta: { id: 0 },
        component: () =>
          import(
            /* webpackChunkName: "ModifyPassword" */ '@/views/Setting/Safe/ModifyPassword/ModifyPassword.vue'
          ),
      },
      // 设置-安全设置-绑定邮箱
      {
        path: '/setting/safe/bind-email',
        name: 'bindEmail',
        meta: { id: 0 },
        component: () =>
          import(/* webpackChunkName: "ModifyEmail" */ '@/views/Setting/Safe/BindEmail/index.vue'),
      },
      // 设置-安全设置-修改邮箱
      {
        path: '/setting/safe/modify-email',
        name: 'modifyEmail',
        meta: { id: 0 },
        component: () =>
          import(
            /* webpackChunkName: "ModifyEmail" */ '@/views/Setting/Safe/ModifyEmail/index.vue'
          ),
      },
      {
        // 设置-安全设置-绑定手机
        path: '/setting/safe/bind-mobile',
        name: 'bindMobile',
        meta: { id: 0 },
        component: () =>
          import(/* webpackChunkName: "BindMobile" */ '@/views/Setting/Safe/BindMobile/index.vue'),
      },
      {
        // 设置-安全设置-修改手机
        path: '/setting/safe/modify-mobile',
        name: 'modifyMobile',
        meta: { id: 0 },
        component: () =>
          import(
            /* webpackChunkName: "ModifyMobile" */ '@/views/Setting/Safe/ModifyMobile/index.vue'
          ),
      },
      {
        // 设置-安全设置-绑定第三方应用
        path: '/setting/safe/bind-third-party',
        name: 'bindThirdParty',
        meta: { id: 0 },
        component: () =>
          import(
            /* webpackChunkName: "BindMobile" */ '@/views/Setting/Safe/BindThirdParty/index.vue'
          ),
      },
      {
        // 设置-安全设置-绑定微信
        path: '/setting/safe/bind-wechat',
        name: 'wechatBind',
        meta: { id: 0 },
        component: () =>
          import(
            /* webpackChunkName: "BindMobile" */ '@/views/Setting/Safe/BindThirdParty/index.vue'
          ),
      },
      {
        // 设置-安全设置-绑定企业微信
        path: '/setting/safe/bind-weixin',
        name: 'weixinBind',
        meta: { id: 0 },
        component: () =>
          import(
            /* webpackChunkName: "BindMobile" */ '@/views/Setting/Safe/BindThirdParty/index.vue'
          ),
      },
      {
        // 设置-安全设置-绑定钉钉
        path: '/setting/safe/bind-dingding',
        name: 'dingdingBind',
        meta: { id: 0 },
        component: () =>
          import(
            /* webpackChunkName: "BindMobile" */ '@/views/Setting/Safe/BindThirdParty/index.vue'
          ),
      },
      {
        // 设置-安全设置-绑定飞书
        path: '/setting/safe/bind-feishu',
        name: 'feishuBind',
        meta: { id: 0 },
        component: () =>
          import(
            /* webpackChunkName: "BindMobile" */ '@/views/Setting/Safe/BindThirdParty/index.vue'
          ),
      },
      {
        // 设置-安全设置-第三方绑定修改
        path: '/setting/safe/modify-third-party',
        name: 'modifyThirdParty',
        meta: { id: 0 },
        component: () =>
          import(
            /* webpackChunkName: "BindMobile" */ '@/views/Setting/Safe/ModifyThirdParty/index.vue'
          ),
      },
      {
        // 设置-安全设置-第三方解除绑定
        path: '/setting/safe/Unbind-party',
        name: 'unbindThirdParty',
        meta: { id: 0 },
        component: () =>
          import(
            /* webpackChunkName: "BindMobile" */ '@/views/Setting/Safe/UnbindThirdParty/index.vue'
          ),
      },
      {
        // 设置-代理设置-新增代理
        path: '/setting/proxy/add-proxy',
        name: 'addProxy',
        meta: { id: 0 },
        component: () =>
          import(/* webpackChunkName: "AddProxy" */ '@/views/Setting/Proxy/AddProxy/index.vue'),
      },
      {
        // error
        path: '/404',
        name: '404',
        meta: { id: 0 },
        component: () => import(/* webpackChunkName: "404" */ '@/views/Error/404.vue'),
      },
      {
        path: '/my-news',
        name: 'myNews',
        meta: { id: 0 },
        component: () => import(/* webpackChunkName: "MyNews" */ '@/views/MyNews/index.vue'),
      },
      {
        path: '/my-news-detail',
        name: 'myNewsDetail',
        meta: { id: 0 },
        component: () =>
          import(/* webpackChunkName: "myNewsDetail" */ '@/views/MyNews/Detail/index.vue'),
      },
      // 人事管理
      {
        // 人事管理
        path: '/personnel',
        name: 'personnel',
        component: () => import(/* webpackChunkName: "Personnel" */ '@/views/Personnel/index.vue'),
        redirect: '/personnel/staff',
        children: [
          // 人事管理-面试中心
          {
            path: '/personnel/audition-center',
            name: 'auditionCenter',
            meta: { id: 0 },
            component: () =>
              import(
                /* webpackChunkName: "AuditionCenter" */ '@/views/Personnel/AuditionCenter/index.vue'
              ),
          },
          // 人事管理-招聘
          {
            path: '/personnel/recruit',
            name: 'recruit',
            meta: { id: 0 },
          },
          // 人事管理-培训
          {
            path: '/personnel/moxueyuan',
            name: 'moxueyuan',
            meta: { id: 0 },
          },
          {
            // 人事管理-员工管理
            path: '/personnel/staff',
            name: 'staff',
            meta: { id: '/personnel/staff' },
            component: () =>
              import(/* webpackChunkName: "Staff" */ '@/views/Personnel/Staff/index.vue'),
          },
          {
            // 人事管理-组织管理
            path: '/personnel/organization',
            name: 'organization',
            meta: { id: '/personnel/organization' },
            component: () =>
              import(
                /* webpackChunkName: "Organization" */ '@/views/Personnel/Organization/index.vue'
              ),
          },
          {
            // 人事管理-入职管理
            path: '/personnel/entry',
            name: 'entry',
            meta: { id: '/personnel/entry' },
            component: () =>
              import(/* webpackChunkName: "Entry" */ '@/views/Personnel/Entry/index.vue'),
          },
          {
            // 人事管理-入职管理
            path: '/entry',
            name: 'entry',
            meta: { id: '/personnel/entry' },
            component: () =>
              import(/* webpackChunkName: "Entry" */ '@/views/Personnel/Entry/index.vue'),
          },
          {
            // 人事管理-薪资管理
            path: '/personnel/payroll',
            name: 'payroll',
            meta: { id: '/personnel/payroll' },
            component: () =>
              import(/* webpackChunkName: "Salary" */ '@/views/Personnel/Salary/index.vue'),
            redirect: '/personnel/payroll/status',
            children: [
              {
                // 人事管理-薪资管理-算薪状态
                path: '/personnel/payroll/status',
                name: 'status',
                meta: { id: '/personnel/payroll/status' },
                component: () =>
                  import(
                    /* webpackChunkName: "payrollpayroll" */ '@/views/Personnel/Salary/Body/body.vue'
                  ),
              },
              {
                // 人事管理-薪资管理-员工工资
                path: '/personnel/payroll/staffSalary',
                name: 'staffSalary',
                meta: { id: '/personnel/payroll/staffSalary' },
                component: () =>
                  import(
                    /* webpackChunkName: "staffSalary" */ '@/views/Personnel/Salary/Body/body.vue'
                  ),
              },
              {
                // 人事管理-薪资管理-周期薪资
                path: '/personnel/payroll/periodic',
                name: 'periodicSalary',
                meta: { id: '/personnel/payroll/periodic' },
                component: () =>
                  import(
                    /* webpackChunkName: "periodic" */ '@/views/Personnel/Salary/Body/body.vue'
                  ),
              },
              {
                // 人事管理-薪资管理-周期薪资
                path: '/personnel/payroll/workloadSalary',
                name: 'workloadSalary',
                meta: { id: '/personnel/payroll/workloadSalary' },
                component: () =>
                  import(
                    /* webpackChunkName: "workloadSalary" */ '@/views/Personnel/Salary/Body/body.vue'
                  ),
              },
              {
                // 人事管理-薪资管理-非周期薪资
                path: '/personnel/payroll/non-periodic',
                name: 'nonPeriodicSalary',
                meta: { id: '/personnel/payroll/non-periodic' },
                component: () =>
                  import(
                    /* webpackChunkName: "nonPeriodic" */ '@/views/Personnel/Salary/Body/body.vue'
                  ),
              },
              {
                // 人事管理-薪资管理-薪资计算-计算详情
                path: '/personnel/payroll/detail',
                name: 'periodicDetail',
                meta: { id: '/personnel/payroll/periodic' },
                component: () =>
                  import(
                    /* webpackChunkName: "periodicDetail" */ '@/views/Personnel/Salary/DetailStep/detailStep.vue'
                  ),
              },
            ],
          },
          {
            // 人事管理-时间管理
            path: '/personnel/time',
            name: 'time',
            meta: { id: '/personnel/time' },
            component: () =>
              import(/* webpackChunkName: "Time" */ '@/views/Personnel/Time/index.vue'),
            redirect: '/personnel/time/time-evaluation',
            children: [
              {
                // 人事管理-时间管理-时间评估
                path: '/personnel/time/time-evaluation',
                name: 'timeEvaluation',
                meta: { id: '/personnel/time/time-evaluation' },
                component: () =>
                  import(
                    /* webpackChunkName: "TimeEvaluation" */ '@/views/Personnel/Time/Body/body.vue'
                  ),
              },
              {
                // 人事管理-时间管理-出勤导入
                path: '/personnel/time/attendance-import',
                name: 'attendanceImport',
                meta: { id: '/personnel/time/attendance-import' },
                component: () =>
                  import(
                    /* webpackChunkName: "attendanceImport" */ '@/views/Personnel/Time/Body/body.vue'
                  ),
              },
              {
                // 人事管理-时间管理-时间配额发放
                path: '/personnel/time/quota-issuance',
                name: 'quotaIssuance',
                meta: { id: '/personnel/time/quota-issuance' },
                component: () =>
                  import(
                    /* webpackChunkName: "quotaIssuance" */ '@/views/Personnel/Time/Body/body.vue'
                  ),
              },
              {
                // 人事管理-时间管理-结果详情
                path: '/personnel/time/detail',
                name: 'detailStep',
                meta: { id: '/personnel/time' },
                component: () =>
                  import(
                    /* webpackChunkName: "timeDetail" */ '@/views/Personnel/Time/DetailStep/detailStep.vue'
                  ),
              },
            ],
          },
          {
            // 人事管理-预算管理
            path: '/personnel/budget',
            name: 'budget',
            meta: { id: '/personnel/budget' },
            component: () =>
              import(/* webpackChunkName: "budget" */ '@/views/Personnel/Budget/index.vue'),
          },
          {
            // 人事管理-访客管理
            path: '/personnel/visitor',
            name: 'visitorManagement',
            meta: { id: '/personnel/visitor' },
            component: () =>
              import(/* webpackChunkName: "visitor" */ '@/views/Personnel/Visitor/index.vue'),
          },
        ],
      },
      {
        path: '/salary-adjust',
        name: 'salaryAdjust',
        meta: { id: '/salary-adjust' },
        component: () =>
          import(/* webpackChunkName: "salaryAdjust" */ '@/views/SalaryAdjust/index.vue'),
      },

      // 企业智脑
      {
        path: '/enterprise-brain',
        name: 'enterpriseBrain',
        meta: { id: '/enterprise-brain' },
        component: () =>
          import(
            /* webpackChunkName: "enterpriseBrain" */ '@/views/EnterpriseBrain/enterpriseBrain.vue'
          ),
      },
      // 行政管理
      {
        path: '/office-admin',
        name: 'officeAdmin',
        component: () =>
          import(/* webpackChunkName: "OfficeAdmin" */ '@/views/OfficeAdmin/index.vue'),
        redirect: '/office-admin/admin-overview',
        meta: { id: '/office-admin' },
        children: [
          {
            // 行政管理-总览
            path: '/office-admin/office-admin',
            name: 'officeAdminOverview',
            meta: { id: '/office-admin/office-admin' },
            component: () =>
              import(
                /* webpackChunkName: "OfficeAdmin" */ '@/views/OfficeAdmin/OfficeAdmin/index.vue'
              ),
            redirect: '/office-admin/admin-overview',
            children: [
              {
                // 行政管理-总览
                path: '/office-admin/admin-overview',
                name: 'adminOverview',
                meta: { id: '/office-admin/admin-overview' },
                component: () =>
                  import(
                    /* webpackChunkName: "AdminOverview" */ '@/views/OfficeAdmin/OfficeAdmin/Body/AdminOverviewBody.vue'
                  ),
              },
              {
                // 行政管理-物品出入库
                path: '/office-admin/admin-item_stock_out_in',
                name: 'adminItemStockOutIn',
                meta: { id: '/office-admin/admin-item_stock_out_in' },
                component: () =>
                  import(
                    /* webpackChunkName: "AdminItemStockOutIn" */ '@/views/OfficeAdmin/OfficeAdmin/Body/ItemStockOutInBody.vue'
                  ),
              },
              {
                // 行政管理-柜子分配
                path: '/office-admin/admin-cabinet_allocation',
                name: 'adminCabinetAllocation',
                meta: { id: '/office-admin/admin-cabinet_allocation' },
                component: () =>
                  import(
                    /* webpackChunkName: "AdminCabinetAllocation" */ '@/views/OfficeAdmin/OfficeAdmin/Body/CabinetAllocationBody.vue'
                  ),
              },
              {
                // 行政管理-物品管理
                path: '/office-admin/admin-item_management',
                name: 'adminItemManagement',
                meta: { id: '/office-admin/admin-item_management' },
                component: () =>
                  import(
                    /* webpackChunkName: "AdminItemManagement" */ '@/views/OfficeAdmin/OfficeAdmin/Body/body.vue'
                  ),
              },
              {
                // 行政管理-柜子管理
                path: '/office-admin/admin-cabinet_management',
                name: 'adminCabinetManagement',
                meta: { id: '/office-admin/admin-cabinet_management' },
                component: () =>
                  import(
                    /* webpackChunkName: "AdminCabinetManagement" */ '@/views/OfficeAdmin/OfficeAdmin/Body/CabinetBody.vue'
                  ),
              },
              {
                // 行政管理-车辆管理
                path: '/office-admin/admin-vehicle-management',
                name: 'adminVehicleManagement',
                meta: { id: '/office-admin/admin-vehicle-management' },
                component: () =>
                  import(
                    /* webpackChunkName: "AdminVehicleManagement" */ '@/views/OfficeAdmin/OfficeAdmin/Body/VehicleManagementBody.vue'
                  ),
              },
              {
                // 行政管理-预算管理
                path: '/office-admin/admin-budget_management',
                name: 'adminBudgetManagement',
                meta: { id: '/office-admin/admin-budget_management' },
                component: () =>
                  import(
                    /* webpackChunkName: "AdminBudgetManagement" */ '@/views/OfficeAdmin/OfficeAdmin/Body/BudgetManagementBody.vue'
                  ),
              },
              {
                // 行政管理-费用管理
                path: '/office-admin/admin-cost_management',
                name: 'adminCostManagement',
                meta: { id: '/office-admin/admin-cost_management' },
                component: () =>
                  import(
                    /* webpackChunkName: "AdminCostManagement" */ '@/views/OfficeAdmin/OfficeAdmin/Body/CostManagementBody.vue'
                  ),
              },
            ],
          },
        ],
      },

      // 企业智脑(利雅嘉)
      {
        path: '/liljas-brain',
        name: 'liljasBrain',
        meta: { id: '/enterprise-brain' },
        component: () => import('@/views/EnterpriseBrain/liljasBrain/index.vue'),
      },

      // 出勤看板
      {
        path: '/attendance-brain',
        name: 'attendanceBrain',
        meta: { id: '/attendance-brain' },
        component: () => import('@/views/EnterpriseBrain/liljasAttendance/index.vue'),
      },

      // 汇报关系
      {
        // 汇报关系
        path: '/org-rel',
        name: 'orgRelationShip',
        meta: { id: '/org-rel' },
        component: () =>
          import(/* webpackChunkName: "OrgRelationShip" */ '@/views/OrgRelationShip/index.vue'),
      },
      // 组织架构
      {
        // 组织架构
        path: '/org-structure',
        name: 'orgStructure',
        meta: { id: '/org-structure' },
        component: () =>
          import(/* webpackChunkName: "orgStructure" */ '@/views/OrgStructure/index.vue'),
      },
      // 员工信息
      {
        // 员工信息
        path: '/employee-information',
        name: 'staffInfo',
        component: () =>
          import(/* webpackChunkName: "employeeInformation" */ '@/views/StaffInfo/index.vue'),
        redirect: '/employee-information/base-info',
        meta: { id: '/employee-information' },
        children: [
          {
            // 员工管理-基本信息
            path: '/employee-information/base-info',
            name: 'baseInfo',
            meta: { id: '/employee-information' },
            component: () =>
              import(
                /* webpackChunkName: "employeeInformationbase" */ '@/views/StaffInfo/InfoBody/infoBody.vue'
              ),
          },
          {
            // 员工管理-时间信息
            path: '/employee-information/time-info',
            name: 'timeInfo',
            meta: { id: '/employee-information' },
            component: () =>
              import(
                /* webpackChunkName: "employeeInformationTime" */ '@/views/StaffInfo/InfoBody/infoBody.vue'
              ),
          },
          {
            // 员工管理-薪资信息
            path: '/employee-information/salary-info',
            name: 'salaryInfo',
            meta: { id: '/employee-information' },
            component: () =>
              import(
                /* webpackChunkName: "employeeInformationSalary" */ '@/views/StaffInfo/InfoBody/infoBody.vue'
              ),
          },
        ],
      },
      // 自助中心
      {
        // 自助中心页面
        path: '/self-help-center',
        name: 'SelfHelpCenter',
        component: () =>
          import(/* webpackChunkName: "selfHelp" */ '@/views/SelfHelpCenter/index.vue'),
        redirect: '/self-help-center/personnel-approval',
        meta: { id: '/self-help-center' },
        children: [
          {
            // 自助中心-人事审批
            path: '/self-help-center/personnel-approval',
            name: 'personnelApproval',
            meta: { id: '/self-help-center' },
            component: () =>
              import(
                /* webpackChunkName: "personnelApproval" */ '@/views/SelfHelpCenter/Approval/index.vue'
              ),
          },
          {
            // 自助中心-考勤审批
            path: '/self-help-center/attendance-approval',
            name: 'attendanceApproval',
            meta: { id: '/self-help-center' },
            component: () =>
              import(
                /* webpackChunkName: "attendanceApproval" */ '@/views/SelfHelpCenter/Approval/index.vue'
              ),
          },
          {
            // 自助中心-行政审批
            path: '/self-help-center/administrative-approval',
            name: 'administrativeApproval',
            meta: { id: '/self-help-center' },
            component: () =>
              import(
                /* webpackChunkName: "administrative" */ '@/views/SelfHelpCenter/Approval/index.vue'
              ),
          },
          {
            // 自助中心-财务审批
            path: '/self-help-center/financial-approval',
            name: 'financialApproval',
            meta: { id: '/self-help-center' },
            component: () =>
              import(
                /* webpackChunkName: "financial" */ '@/views/SelfHelpCenter/Approval/index.vue'
              ),
          },
          {
            // 自助中心-其他
            path: '/self-help-center/other',
            name: 'other',
            meta: { id: '/self-help-center' },
            component: () =>
              import(
                /* webpackChunkName: "helpcenter" */ '@/views/SelfHelpCenter/Approval/index.vue'
              ),
          },
        ],
      },
      // OKR工作坊
      {
        // OKR工作坊页面
        path: '/okrWorkshop',
        name: 'okrWorkshop',
        component: () =>
          import(/* webpackChunkName: "okrWorkshop" */ '@/views/OkrWorkshop/index.vue'),
        redirect: '/okrWorkshop/myOKR',
        meta: { id: '/okrWorkshop' },
        children: [
          {
            // OKR工作坊-我的OKR
            path: '/okrWorkshop/myOKR',
            name: 'myOKR',
            meta: { id: '/okrWorkshop/myOKR' },
            component: () =>
              import(/* webpackChunkName: "myOKR" */ '@/views/OkrWorkshop/Body/body.vue'),
          },
          {
            // OKR工作坊-团队OKR
            path: '/okrWorkshop/teamOKR',
            name: 'teamOKR',
            meta: { id: '/okrWorkshop/teamOKR' },
            component: () =>
              import(/* webpackChunkName: "teamOKR" */ '@/views/OkrWorkshop/Body/body.vue'),
          },
          {
            // OKR工作坊-部门OKR
            path: '/okrWorkshop/departmentOKR',
            name: 'departmentOKR',
            meta: { id: '/okrWorkshop/departmentOKR' },
            component: () =>
              import(/* webpackChunkName: "departmentOKR" */ '@/views/OkrWorkshop/Body/body.vue'),
          },
          {
            // OKR工作坊-公司OKR
            path: '/okrWorkshop/companyOKR',
            name: 'companyOKR',
            meta: { id: '/okrWorkshop/companyOKR' },
            component: () =>
              import(/* webpackChunkName: "companyOKR" */ '@/views/OkrWorkshop/Body/body.vue'),
          },
        ],
      },
      // 帮助
      {
        path: '/help',
        name: 'help',
        component: () => import(/* webpackChunkName: "HelpIndex" */ '@/views/Help/index.vue'),
        redirect: '/help/first-menu',
        meta: { id: 0 },
        children: [
          {
            // 帮助-第一层
            path: '/help/first-menu',
            name: 'firstMenu',
            meta: { id: 0 },
            component: () =>
              import(/* webpackChunkName: "firstMenu" */ '@/views/Help/FirstMenu/index.vue'),
          },
        ],
      },
      // 我的需求
      {
        // 我的需求
        path: '/my-needs',
        name: 'myNeeds',
        meta: { id: '/my-needs' },
        component: () => import(/* webpackChunkName: "myneeds" */ '@/views/MyNeeds/index.vue'),
      },
      // 我的待办
      {
        path: '/my-agent',
        name: 'myAgent',
        meta: { id: '/my-agent' },
        component: () => import(/* webpackChunkName: "myagent" */ '@/views/MyAgent/index.vue'),
      },
      // 我的工资
      {
        path: '/salary',
        name: 'salary',
        meta: { id: '/salary' },
        component: () => import(/* webpackChunkName: "salary" */ '@/views/MyWage/index.vue'),
      },
      // 时间配额
      {
        path: '/time-quota',
        name: 'timeQuota',
        meta: { id: '/time-quota' },
        component: () => import(/* webpackChunkName: "timequota" */ '@/views/TimeQuota/index.vue'),
      },
      // 我的考勤
      {
        path: '/my-attendance',
        name: 'myAttendance',
        meta: { id: '/my-attendance' },
        component: () =>
          import(/* webpackChunkName: "myattendance" */ '@/views/MyAttendance/index.vue'),
      },
      // 考勤控制室
      {
        path: '/time-admin',
        name: 'timeAdmin',
        meta: { id: '/time-admin' },
        component: () => import(/* webpackChunkName: "timeadmin" */ '@/views/TimeAdmin/index.vue'),
      },
      // 文档中心
      {
        path: '/docCenter',
        name: 'docCenter',
        meta: { id: '/docCenter' },
        component: () =>
          import(/* webpackChunkName: "myattendance" */ '@/views/DocCenter/index.vue'),
      },
      //我的工资扫码验证
      {
        path: '/no-secret-wage/:key',
        name: 'noSecretWage',
        meta: { id: '/salary' },
        component: () => import('@/layouts/Layout.vue'),
      },
      // 项目管理
      {
        // 项目管理
        path: '/project-manage',
        name: 'projectManage',
        component: () =>
          import(/* webpackChunkName: "employeeInformation" */ '@/views/ProjectManage/index.vue'),
        redirect: '/project-manage/project-data',
        meta: { id: '/project-manage' },
        children: [
          {
            // 项目管理-项目数据
            path: '/project-manage/project-data',
            name: 'projectData',
            meta: { id: '/project-manage' },
            component: () =>
              import(
                /* webpackChunkName: "employeeInformationbase" */ '@/views/ProjectManage/Body/index.vue'
              ),
          },
          {
            // 项目管理-任务日报
            path: '/project-manage/task-daily',
            name: 'taskDaily',
            meta: { id: '/project-manage' },
            component: () =>
              import(
                /* webpackChunkName: "employeeInformationTime" */ '@/views/ProjectManage/Body/index.vue'
              ),
          },
        ],
      },
      ...routerList2,
    ],
  },
];

// 白名单
const baseRouterList = [
  {
    path: '/login',
    name: 'login',
    meta: { id: 0 },
    component: () => import(/* webpackChunkName: "login" */ '@/views/Login/Login.vue'),
  },
  //微信跳转登录
  {
    path: '/no-secret-wechat/:key',
    name: 'noSecretWechat',
    meta: { id: 'no-secret-wechat' },
    component: () => import('@/views/Login/Login.vue'),
  },
  //企业微信跳转登录
  {
    path: '/no-secret-weix/:key',
    name: 'noSecretWeix',
    meta: { id: 'no-secret-weix' },
    component: () => import('@/views/Login/Login.vue'),
  },
  //钉钉跳转登录
  {
    path: '/no-secret/:key',
    name: 'noSecret',
    meta: { id: 'no-secret' },
    component: () => import(/* webpackChunkName: "noSecret" */ '@/views/Login/Login.vue'),
  },
  //飞书跳转登录
  {
    path: '/no-secret-feishu/:key',
    name: 'noSecretFeis',
    meta: { id: 'no-secret-feis' },
    component: () => import(/* webpackChunkName: "noSecretFeis" */ '@/views/Login/Login.vue'),
  },
  //飞书扫码登录
  {
    path: '/scan-code-feishu/:key',
    name: 'scanCodeFeis',
    meta: { id: 'no-secret-feis' },
    component: () => import(/* webpackChunkName: "noSecretFeis" */ '@/views/Login/Login.vue'),
  },
  {
    path: '',
    name: 'custom',
    meta: { id: 0 },
    component: () => import(/* webpackChunkName: "customlogin" */ '@/views/Login/Login.vue'),
  },
  {
    path: '/qrcode',
    name: 'qrcode',
    meta: { id: 0 },
    component: () => import(/* webpackChunkName: "qrcode" */ '@/views/Login/QrCode.vue'),
  },
  {
    path: '/forget-password',
    name: 'forget-password',
    meta: { id: 0 },
    component: () => import(/* webpackChunkName: "forgetPassword" */ '@/views/Login/ForgetPwd.vue'),
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    meta: { id: 0 },
    component: () => import(/* webpackChunkName: "resetPassword" */ '@/views/Login/ResetPwd.vue'),
  },
  {
    path: '/Sendtothemailbox',
    name: 'Sendtothemailbox',
    meta: { id: 0 },
    component: () =>
      import(/* webpackChunkName: "Sendtothemailbox" */ '@/views/Login/Sendtothemailbox.vue'),
  },
  {
    path: '/visitor',
    name: 'visitor',
    meta: { id: 0, type: 0 },
    component: () => import(/* webpackChunkName: "candidate" */ '@/views/Visitor/index.vue'),
  },
  {
    path: '/candidate',
    name: 'candidate',
    meta: { id: 0, type: 0 },
    component: () => import(/* webpackChunkName: "candidate" */ '@/views/Candidate/index.vue'),
  },
  {
    path: '/complete',
    name: 'complete',
    meta: { id: 0 },
    component: () => import(/* webpackChunkName: "complete" */ '@/views/Complete/index.vue'),
  },
  {
    path: '/InductionManagement',
    name: 'InductionManagement',
    meta: { id: 0 },
    component: () =>
      import(
        /* webpackChunkName: "InductionManagement" */ '@/views/Personnel/Entry/InductionManagement.vue'
      ),
  },
  {
    // 系统发布
    path: '/updating',
    name: 'updating',
    meta: { id: 0 },
    component: () => import(/* webpackChunkName: "updating" */ '@/views/Error/updating.vue'),
  },
];

export { mainRouterList, baseRouterList };
